import React, { useState, useEffect, Component } from "react";
import { Col, Row, Modal, Button, Alert } from "react-bootstrap";
import { FaRegListAlt, FaQuestionCircle } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import AllActivities from "../../../Components/AllActivities";
import SponsershipList from "../../../Components/SponsershipList";
import MessagesList from "../../../Components/MessagesList";
import { getRecentMessagesForSTM } from "../../../Services/MessagesService";
import { getSponsershipList } from "../../../Services/SponsershipService";
import getMessagesList from "../../../Services/MessagesService";
import getAllActivities from "../../../Services/AllActivities";
import {
  recentActivityPerPage,
  supportRecentSponsorshipsPerPage,
  recentMessagesPerPage,
} from "../../../Utilities/Helper";
import { toast } from "react-toastify";
import { get } from "../../../Services/AxiosService";
import { getUserDetailsAPI } from "../../../Utilities/APIHelper";
import { checkGroupSubscriptionStatus } from "../../../Services/StripeService";
import Logout from "../../../Services/LogoutService.js";
import TermsReacceptanceModal from "../../../Components/Shared/TermsReacceptanceModal";
import { useTermsAcceptance } from "../../../hooks/useTermsAcceptance";

export default function SupportDashboard() {
  const [RecentActivities, setActivities] = useState([]);
  const [sponsership, setSponsership] = useState([]);
  const [Messages, setMessages] = useState([]);
  const [showSpinnerForActivities, setShowSpinnerForActivities] =
    useState(true);
  const [showSpinnerForSponsorships, setShowSpinnerForSponsorships] =
    useState(true);
  const [showSpinnerForMessages, setShowSpinnerForMessages] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [groupId, setGroupId] = useState(null);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(null);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState("");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const history = useHistory();

  // Terms acceptance functionality
  const {
    showTermsModal,
    termsAccepted,
    acceptTerms,
    declineTerms,
    openTermsInNewWindow,
    currentTermsVersion,
  } = useTermsAcceptance(email);

  // getting jobs list list

  useEffect(() => {
    function activitiesData() {
      getAllActivities("recordperpage=" + recentActivityPerPage)
        .then((res) => {
          const result = JSON.parse(res.response);
          const data = result.userActivity;
          setActivities(data);
          setShowSpinnerForActivities(false);
        })
        .catch((err) => {
          console.log("Support: ", err);
          setShowSpinnerForActivities(false);
        });
    }
    activitiesData();
  }, []);

  // getting Sponsership list
  useEffect(() => {
    function sponsershipData() {
      const filter =
        "recordperpage=" + supportRecentSponsorshipsPerPage + "&IsPending=true";
      getSponsershipList(filter)
        .then((res) => {
          const result = JSON.parse(res.response);
          setSponsership(result.jobSeekers);
          setShowSpinnerForSponsorships(false);
        })
        .catch((err) => {
          setShowSpinnerForSponsorships(false);
          console.log("Sponsorship: ", err);
        });
    }
    sponsershipData();
  }, []);

  // getting message list
  useEffect(() => {
    function messagesData() {
      getRecentMessagesForSTM("?recordperpage=" + recentMessagesPerPage)
        .then((res) => {
          const result = JSON.parse(res.response);
          var resultArray = [];
          result.forEach((element) => {
            var obj = {};
            obj.name = element.fullName;
            obj.text = element.jobSeekerSponshirShipMsg;
            obj.date = element.createdDate;
            obj.profilePhoto = element.profilePhoto;
            resultArray.push(obj);
          });
          setMessages(resultArray);
          setShowSpinnerForMessages(false);
        })
        .catch((err) => {
          console.log("Message: ", err);
          setShowSpinnerForMessages(false);
        });
    }
    messagesData();
  }, []);

  const checkSubscriptionStatus = async (groupId) => {
    if (!groupId) return;

    setSubscriptionLoading(true);
    setSubscriptionError("");

    try {
      const result = await checkGroupSubscriptionStatus(groupId);

      if (result.success) {
        setHasActiveSubscription(result.hasActiveSubscription);
        if (!result.hasActiveSubscription) {
          setShowSubscriptionModal(true);
        }
      } else {
        setHasActiveSubscription(false);
        setSubscriptionError("Unable to verify subscription status");
        setShowSubscriptionModal(true);
      }
    } catch (error) {
      console.error("Error checking subscription:", error);
      setHasActiveSubscription(false);
      setSubscriptionError("Failed to check subscription status");
      setShowSubscriptionModal(true);
    } finally {
      setSubscriptionLoading(false);
    }
  };

  const handleLogout = () => {
    Logout();
    sessionStorage.clear();

    history.push(process.env.PUBLIC_URL + "/home");
  };

  const handleModalClose = () => {
    handleLogout();
  };

  useEffect(() => {
    async function getName() {
      get(getUserDetailsAPI)
        .then((res) => {
          let response = res.data.response;
          setName(response.firstName);
          setEmail(response.email);

          // Extract groupId and check subscription
          if (response.groupId) {
            setGroupId(response.groupId);
            checkSubscriptionStatus(response.groupId);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    getName();
  }, []);

  return (
    <div className="container p-0">
      <TermsReacceptanceModal
        show={showTermsModal}
        onAccept={acceptTerms}
        onDecline={declineTerms}
        onOpenTerms={openTermsInNewWindow}
        currentVersion={currentTermsVersion}
      />
      <h1 className="page-title">
        Hello {name} <small>(Support team)</small>
        <Button
          variant="link"
          className="p-0 ml-3 d-inline-flex align-items-center"
          onClick={() => setShowHelp(!showHelp)}
          title="Welcome Information"
        >
          <FaQuestionCircle size={24} className="text-info" />
          <span className="text-info ml-2" style={{ fontSize: '1rem', fontWeight: 'normal' }}>Help</span>
        </Button>
      </h1>

      {/* Subscription Modal */}
      <Modal
        show={showSubscriptionModal}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <span className="icon icon-warning mr-2 text-warning"></span>
            Subscription Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Your group does not have an active subscription.</strong>
          </p>
          <p>
            Support team members cannot access the system without an active
            group subscription. Please contact your Group Leader to activate a
            subscription for your group.
          </p>
          {subscriptionError && (
            <div className="alert alert-danger mt-3">
              <small>{subscriptionError}</small>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleModalClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Show welcome message when no activities, messages, or sponsorships exist and loading is complete OR when help button is clicked */}
      {((RecentActivities.length === 0 &&
        Messages.length === 0 &&
        sponsership.length === 0 &&
        !showSpinnerForActivities &&
        !showSpinnerForMessages &&
        !showSpinnerForSponsorships) ||
        showHelp) && (
          <Alert
            variant="info"
            className="my-4"
            dismissible={showHelp}
            onClose={() => setShowHelp(false)}
          >
            <Alert.Heading>Welcome to JobInfoNetwork!</Alert.Heading>
            <p>
              Welcome to JobInfoNetwork and thank you for your willingness to assist job seekers in your organization! As an employed member of your organization, you will very likely have information that could prove to be very valuable to a job seeker in your field, in your organization.
            </p>
            <p>
              If a job seeker in your organization chooses you for networking, you will receive a résumé from that jobseeker, which you are asked to thoughtfully review and then choose one of the following three responses that will accompany the resume:
            </p>
            <ol>
              <li>Please have job seeker contact me at the following email address. (Note: the job seeker was not provided your contact information, only your company and your position.)</li>
              <li>Here is some information that may be helpful. (Job seeker will not be provided your contact info.)</li>
              <li>I'm not aware of any opportunities for this job seeker. (Job seeker will not be provided your contact info.) </li>
            </ol>
            <p className="mb-0">
              Thank you, again.
            </p>
          </Alert>
        )}

      <div className="dashboard-wrapper">
        <Row>
          <Col md={7}>
            <div className="dashboard-box activity dashboard-col-bg">
              <h2 className="page-sub-title">Recent Activity</h2>
              <AllActivities
                activities={RecentActivities}
                showSpinner={showSpinnerForActivities}
              />
              <Link
                className="btn btn-warning btn-xs white mt-3"
                to={`${process.env.PUBLIC_URL}/support/activitieslist`}
              >
                <span className="icon icon-list_alt mr-3"></span> View more
              </Link>
            </div>

            <div className="dashboard-box activity dashboard-col-bg mt-5">
              <h2 className="page-sub-title">Messages</h2>
              <MessagesList
                messages={Messages}
                showSpinner={showSpinnerForMessages}
              />
              <Link
                to={`${process.env.PUBLIC_URL}/support/messages`}
                className="btn btn-warning btn-xs white mt-3"
              >
                <span className="icon icon-chat_bubble_outline mr-3"></span>{" "}
                View all messages
              </Link>
            </div>
          </Col>
          <Col md={5}>
            <div className="dashboard-box resume dashboard-col-bg sponser-dashboard-col sponsership-dashboard-list">
              <h2 className="page-sub-title">New Sponsorship Requests</h2>
              <SponsershipList
                sponsers={sponsership}
                showSpinner={showSpinnerForSponsorships}
              />
              <Link
                to={`${process.env.PUBLIC_URL}/support/sponsorship`}
                className="btn btn-warning btn-xs white mt-3"
              >
                <span className="icon-people_outline mr-3"></span> View all
                sponsorships
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

// export default Dashboard;
